import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public isLoadingIntercept: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  public isLoadingManual: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  constructor() { }
}
